<div class="alarm_screen">
  <div class="alarm_container">
    <div class="alarm_body">
      <!-- <div class="row" *ngIf="action !== 'update'">
        <div class="flex-between p-0">
          <label>Linked Account List</label>
          <div class="flex-start filters">
            <div class="flex-start">
              <input type="checkbox" id="select_all_accounts" (change)="selectAllchilds($event)" />
              <label for="select_all_accounts">Select All</label>
            </div>
          </div>
        </div>

        <select class="form-control" id="childs" [(ngModel)]="ri.lids
        data-live-search="true" multiple required>
        <option *ngFor="let master of linkedAccounts['list']" [value]="master.accountId">
          {{ master.accountId }} ({{master.accountName}})
        </option>
      </select>
      </div> -->

      <div
        class="row"
        [ngStyle]="{ display: ri.riType == 'OnDemand' ? 'none' : 'block' }"
      >
        <label>Instance Types</label>
        <select
          class="form-control"
          id="instanceTypes"
          (change)="fetchRICost()"
          [(ngModel)]="ri.instanceType"
          data-live-search="true"
        >
          <option *ngFor="let type of instanceTypes" value="{{ type }}">
            {{ type }}
          </option>
        </select>
      </div>

      <div class="row">
        <label>OS</label>
        <select
          class="form-control"
          id="platformsList"
          (change)="fetchRICost()"
          [(ngModel)]="ri.os"
          data-live-search="true"
        >
          <option *ngFor="let platform of platformTypes" value="{{ platform }}">
            {{ platform }}
          </option>
        </select>
      </div>

      <div
        class="row"
        [ngStyle]="{ display: ri.riType == 'OnDemand' ? 'none' : 'block' }"
      >
        <label>Region</label>
        <select
          class="form-control"
          id="regionsList"
          (change)="fetchRICost()"
          [(ngModel)]="ri.region"
          data-live-search="true"
        >
          <option *ngFor="let region of regions" value="{{ region.id }}">
            {{ region.name }}
          </option>
        </select>
      </div>

      <div class="row">
        <label>Quantity</label>
        <input type="number" class="form-control" [(ngModel)]="ri.quantity" />
      </div>

      <div class="row">
        <label>RI Type</label>
        <select
          class="form-control"
          id="billingTypes"
          [(ngModel)]="ri.riType"
          (change)="fetchRICost()"
          data-live-search="true"
        >
          <option *ngFor="let type of RITypes" value="{{ type }}">
            {{ type }}
          </option>
        </select>
      </div>

      <div
        class="row"
        [ngStyle]="{ display: ri.riType == 'OnDemand' ? 'none' : 'block' }"
      >
        <label>RI hourly cost</label>
        <input type="text" class="form-control" [(ngModel)]="ri.riCost" />
      </div>

      <div class="row">
        <label>Discount percentage:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="ri.discountPercentage"
        />
      </div>

      <div class="row">
        <label>Period:</label>
        <input
          type="text"
          id="dataRangePicker"
          [(ngModel)]="dateRange"
          class="form-control"
          style="width: 300px"
          placeholder="Select date"
          [disabled]="action == 'update'"
        />
      </div>
    </div>
  </div>

  <style>
    .alarm_screen label {
      padding: 0 !important;
    }
  </style>
</div>
